export default __webpack_public_path__ + "static/media/TokiRGB_yellow.4fbcb72c.png";